import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, CheckCircle2, Palette, TrendingDown } from 'lucide-react';
export function ProductSection() {
  const highlights = [{
    icon: Sparkles,
    text: '40 ideias escolhidas a dedo',
    color: 'from-amber-500 to-yellow-500'
  }, {
    icon: Palette,
    text: 'Para todos os estilos de noiva',
    color: 'from-amber-600 to-yellow-600'
  }, {
    icon: CheckCircle2,
    text: 'Método simples e testado',
    color: 'from-green-500 to-emerald-500'
  }, {
    icon: TrendingDown,
    text: 'Gastando pouco',
    color: 'from-amber-500 to-yellow-600'
  }];
  return <section className="py-12 md:py-20 bg-gradient-to-br from-stone-50 via-amber-50/30 to-stone-50" data-id="element-266">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-267">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-10" data-id="element-268">
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl font-bold text-stone-900 mb-6 md:mb-8" data-id="element-269">
            O método por trás do acabamento{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 whitespace-nowrap" data-id="element-270">
              de Boutique
            </span>
          </h2>

          <div className="max-w-4xl mx-auto" data-id="element-271">
            <p className="text-xl md:text-2xl text-stone-700 leading-relaxed mb-8 md:mb-10" data-id="element-272">
              O{' '}
              <span className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 whitespace-nowrap" data-id="element-273">
                Efeito Boutique™
              </span>{' '}
              é um método simples para criar lembrancinhas com aparência
              profissional, usando materiais acessíveis, acabamento certo e
              apresentação elegante.
            </p>

            {/* Highlight Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mb-8 md:mb-10" data-id="element-274">
              {highlights.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1,
              duration: 0.5
            }} className="bg-white p-4 md:p-5 rounded-xl shadow-lg border border-stone-100 flex items-center gap-3 md:gap-4" data-id="element-275">
                  <div className={`bg-gradient-to-br ${item.color} p-2.5 md:p-3 rounded-lg flex-shrink-0`} data-id="element-276">
                    <item.icon className="w-5 h-5 md:w-6 md:h-6 text-white" data-id="element-277" />
                  </div>
                  <p className="text-base md:text-lg font-semibold text-stone-800 text-left" data-id="element-278">
                    {item.text}
                  </p>
                </motion.div>)}
            </div>

            {/* Key Benefit Callout */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4,
            duration: 0.6
          }} className="bg-gradient-to-r from-amber-500 to-yellow-600 p-6 md:p-8 rounded-2xl shadow-2xl text-white" data-id="element-279">
              <p className="text-lg md:text-xl font-medium leading-relaxed" data-id="element-280">
                Você aprende a criar lembrancinhas que{' '}
                <span className="font-bold underline decoration-2 underline-offset-4" data-id="element-281">
                  parecem caras
                </span>
                , mas custam uma fração do preço — sem precisar de habilidades
                especiais.
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}